import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "df-progress" };
const _hoisted_2 = ["aria-current"];
import { useI18n } from "vue-i18n";
import { useDonation } from "../../context/donationContext";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StepProgress',
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const { progressSteps, lang } = useDonation();
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(progressSteps), (s) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: s.id,
                        class: "df-progress__item"
                    }, [
                        _createElementVNode("span", {
                            class: _normalizeClass(["df-progress__circle", { 'is-active': s.done || s.current }])
                        }, [
                            (s.done)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("✓")
                                ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(s.number), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                        ], 2 /* CLASS */),
                        _createElementVNode("span", {
                            class: _normalizeClass(["df-progress__label", { 'is-active': s.done || s.current, 'is-current': s.current }]),
                            "aria-current": s.current ? 'step' : undefined
                        }, _toDisplayString(_unref(t)(s.label, {}, { locale: _unref(lang) })), 11 /* TEXT, CLASS, PROPS */, _hoisted_2),
                        (s.hasConnector)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["df-progress__bar", { 'is-done': s.done }])
                            }, null, 2 /* CLASS */))
                            : _createCommentVNode("v-if", true)
                    ]));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
